<template>
    <v-dialog v-model="dialog" width="900" persistent scrollable>
        <v-card :disabled="load">
            <v-card-title class="pb-2">
                Cargar ticket
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pt-6">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="6" sm="3" md="2" class="py-0">
                            <v-autocomplete v-model="empresa" label="Empresa" item-text="nombre" return-object
                                :items="familias" :rules="[rules.required]" validate-on-blur autofocus outlined
                                dense></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="3" class="py-0">
                            <v-autocomplete v-model="sucursal" label="Sucursal" item-text="provincia" item-value="id"
                                :items="sucursales.filter(sucursal => sucursal.familia_id == empresa?.id)"
                                :rules="[rules.required]" validate-on-blur outlined dense
                                @change="local = null"></v-autocomplete>
                        </v-col>
                        <v-col :cols="cargaInc ? 12 : 6" :sm="cargaInc ? 4 : 3" class="py-0">
                            <v-text-field v-if="!es_dba" v-model="$store.state.username" label="Contacto" outlined
                                readonly filled dense></v-text-field>
                            <v-autocomplete v-else v-model="solicitante" label="Solicitante"
                                item-text="nombre_completo_usuario" item-value="id" :items="solicitantes"
                                :rules="[rules.required]" validate-on-blur outlined dense
                                return-object></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="3" class="py-0">
                            <v-autocomplete v-if="es_dba" v-model="origen" label="Origen" item-text="nombre"
                                item-value="origen_id" :items="origenes" :rules="[rules.required]" validate-on-blur
                                outlined dense clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="3" class="py-0">
                            <v-text-field v-model.trim="teamviewer" label="Team Viewer" :rules="[rules.required]"
                                validate-on-blur outlined dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" :md="cargaInc ? 5 : 6" class="py-0">
                            <v-text-field v-model.trim="asunto" label="Asunto" :rules="[rules.required]"
                                validate-on-blur outlined dense></v-text-field>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <v-textarea v-model="descripcion" rows="3" :rules="[rules.required]" validate-on-blur
                                outlined dense></v-textarea>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                            <FileDropzone :files="archivos"
                                :tipos="['.txt', '.png', '.jpg', '.webp', '.doc', '.docx', '.csv', '.xls', '.xlsx', '.pdf']"
                                :multiple="true" :max_size="25" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="d-flex justify-end pb-4">
                <v-btn color="error" class="mr-3" :disabled="load" @click="dialog = false">
                    Cancelar
                </v-btn>
                <BtnConfirmar nombre="Cargar" :texto="`¿Desea cargar el incidente <strong>${asunto}</strong>?`"
                    :loading="load" @action="guardar()" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { getBase64 } from '../../util/utils'
import BtnConfirmar from '../util/BtnConfirmar.vue';
import FileDropzone from '../util/FileDropzone.vue';
import { convertImageToWebp } from '../../util/imagenes';

export default {
    data() {
        return {
            load: false,

            asunto: '',
            teamviewer: '',
            descripcion: '',
            solicitante: null,
            solicitantes: [],
            empresa: {
                id: 0
            },
            sucursal: null,
            local: null,
            archivos: [],
            rules: {
                required: value => !!value || 'Campo requerido'
            },
            sucursalesFiltradas: [],
            es_dba: false,
            origenes: [],
            origen: 1
        }
    },
    async created() {
        this.$store.state.loading = true
        this.$store.state.loading = false


        await this.$store.dispatch('roles/getRolesDelUsuario').then(async res => {
            if (res.exito) {
                if (res.data.some(rol => rol.Rol_id === 1)) {
                    this.es_dba = true
                    await this.$store.dispatch('usuarios/get_usuarios', {
                        username: '',
                        email: '',
                        rol: null,
                        empresa: null,
                        inhabilitado: 0
                    }).then(res => {
                        if (res.exito) {
                            this.solicitantes = res.data
                            this.solicitantes.forEach(sol => {
                                sol.nombre_completo_usuario = `${sol.nombre} ${sol.apellido} - ${sol.username}`.toUpperCase()
                                sol.nombre_completo = `${sol.nombre} ${sol.apellido}`.toUpperCase()
                            })
                        } else {
                            this.$store.dispatch('show_snackbar', {
                                text: res.message,
                                color: 'error'
                            })
                        }
                    })

                    // ORIGENES
                    await this.$store.dispatch('tickets/getOrigenes').then(res => {
                        if (res.exito) {
                            this.origenes = res.data
                        } else {
                            this.$store.dispatch('show_snackbar', {
                                text: res.message,
                                color: 'error'
                            })
                        }
                    })



                } else {
                    this.es_dba = false
                }
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: res.message,
                    color: 'error'
                })
            }
        })
        await this.$store.dispatch('genericos/get_sucursales')
        await this.init_form()

        if (this.familias.length === 1) {
            this.empresa = this.familias[0]
        }
    },
    props: {
        value: Boolean,
        titulo: {
            type: String,
            default: ''
        },
    },
    computed: {
        ...mapState('incidentes', ['favorito', 'cargaInc']),
        ...mapState('genericos', ['sucursales']),
        ...mapState(['familias']),
        ...mapGetters(['una_empresa']),
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    components: {
        BtnConfirmar,
        FileDropzone
    },
    watch: {
        async dialog(val) {
            if (val) {
                await new Promise(resolve => setTimeout(resolve, 1))
                this.init_form()
            } else {
                this.limpiar()
            }
        }
    },
    methods: {
        async guardar() {

            this.$store.state.loading = true
            if (this.$refs.form.validate()) {
                // valido si en algun lado de la descripcion puso adjunto para avisarle por si no adjuntó nada
                const tiene_adjunto = this.descripcion.toLowerCase().indexOf('adjunto') >= 0
                const tiene_archivo = this.descripcion.toLowerCase().indexOf('archivo') >= 0
                if ((tiene_adjunto || tiene_archivo) && this.archivos.length == 0) {
                    let ups_me_olvide_el_archivo = false
                    await this.$swal.fire({
                        icon: 'warning',
                        html: `Se encontró la palabra <strong>${tiene_archivo ? 'archivo' : ''} ${tiene_adjunto ? 'adjunto' : ''}</strong> en el cuerpo del mensaje
              pero no se seleccionó ningún archivo.<div style="font-size: 20px; margin-top: 12px"><strong>¿Desea cargar el incidente de todas formas?</strong></div>`,
                        confirmButtonText: 'Sí, cargar de todas formas',
                        denyButtonText: 'No, seleccionar archivos',
                        denyButtonColor: '#3085d6',
                        showDenyButton: true,
                        focusDeny: true
                    })
                        .then((res) => {
                            // si pone que no o hace click fuera del modal no hace nada
                            if (!res.isConfirmed) {
                                ups_me_olvide_el_archivo = true
                            }
                        })
                    if (ups_me_olvide_el_archivo) return
                }
                this.load = true
                let archivos = []

                const nombreArchivos = []


                if (this.archivos.length > 0) {
                    for (const archivo of this.archivos) {
                        try {
                            // Convertir a WebP si es imagen, o dejar el archivo original si no lo es
                            const archivoConvertido = await convertImageToWebp(archivo)

                            // Agregar el nombre del archivo convertido (con extensión .webp si aplicó)
                            nombreArchivos.push(archivoConvertido.name)

                            // Convertir a base64
                            const fileBase64 = await getBase64(archivoConvertido)

                            archivos.push(fileBase64)
                        } catch (error) {
                            this.load = false
                            this.$store.state.loading = false
                            this.$store.dispatch('show_snackbar', {
                                text: error.message || `No se pudo procesar el archivo ${archivo.name}`,
                                color: 'error'
                            })
                            return
                        }
                    }
                }

                let solicitante_nombre = ''
                if (this.es_dba) {
                    solicitante_nombre = this.solicitante.nombre_completo
                    // solicitante_nombre = 
                } else {
                    solicitante_nombre = `${this.$store.state.usuario.nombre} ${this.$store.state.usuario.apellido}`.toUpperCase()
                }
                await this.$store.dispatch('tickets/nuevoTicket', {
                    asunto: this.asunto,
                    teamviewer: this.teamviewer,
                    descripcion: this.descripcion,
                    empresa: this.empresa.id,
                    sucursal: this.sucursal,
                    origen: this.origen,
                    solicitante_nombre,
                    solicitante: this.solicitante?.id || null
                })
                    .then(async (res) => {
                        if (res.exito) {
                            if (archivos.length === 0) {
                                this.dialog = false
                                await this.$swal.fire({
                                    icon: res.exito ? 'success' : 'warning',
                                    title: res.message,
                                })
                                this.$emit('actualizar')
                                return
                            }

                            // CARGO LOS ARCHIVOS       
                            await this.$store
                                .dispatch('tickets/cargarArchivos', {
                                    archivos,
                                    nombreArchivos,
                                    ticket_id: res.data.ticket_id,
                                    estado_id: res.data.estado_id,
                                    comentario_id: null
                                })
                                .then(resArchivos => {
                                    if (resArchivos.exito) {
                                        this.dialog = false
                                        if (resArchivos.feedbackFallidos.length > 0) {
                                            this.$swal.fire({
                                                icon: 'info',
                                                title: resArchivos.message,
                                                html: `<strong>${resArchivos.feedbackFallidos}</strong>`,
                                                width: '450px'
                                            })
                                        } else {
                                            this.$swal.fire({
                                                icon: 'info',
                                                title: resArchivos.message,
                                            })
                                        }
                                    } else {
                                        this.$store.dispatch('show_snackbar', {
                                            text: resArchivos.message,
                                            color: 'error'
                                        })
                                    }
                                })
                        }
                        this.$emit('actualizar')
                    })
                    .catch(error => {
                        this.$store.state.loading = false
                        this.$store.dispatch('show_snackbar', {
                            text: error.message,
                            color: 'error'
                        })
                    })
                this.load = false
            }
            this.$store.state.loading = false
        },
        async init_form() {
            if (this.titulo) {
                this.asunto = this.titulo
            }

            if (this.familias.length == 1) {
                this.empresa = this.familias[0]
            }

        },

        setSucursales() {
            this.sucursal = null
            if (this.empresa) {
                this.sucursalesFiltradas = this.sucursales.filter(
                    suc => suc.familia_id === this.empresa.id
                )
                if (this.sucursalesFiltradas.length === 1) {
                    this.sucursal = this.sucursalesFiltradas[0].sucursal_ora
                }
            } else {
                this.sucursalesFiltradas = []
            }
        },

        limpiar() {
            this.$refs.form.resetValidation()
            this.asunto = ''
            this.teamviewer = ''
            this.descripcion = ''
            this.solicitante = ''
            this.empresa = null
            this.sucursal = null
            this.local = null
            this.archivos = []
        }
    }
}
</script>
